import React from "react";

export const RandomizeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M13.6354 9.09512C13.4502 10.8351 12.4643 12.4655 10.833 13.4074C8.12269 14.9722 4.65701 14.0436 3.0922 11.3332L2.92554 11.0446M2.36417 7.90443C2.54937 6.1645 3.53523 4.53401 5.16655 3.59217C7.87688 2.02736 11.3426 2.95599 12.9074 5.66631L13.074 5.95499M2.32886 12.5438L2.81689 10.7224L4.63826 11.2105M11.3617 5.78909L13.183 6.27713L13.6711 4.45576"
        stroke="#1E22FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
